import { lazy } from 'react';

const NotificationList = lazy(() => import('./notification-list'));;

export default {
  NotificationList,
};
